import { CustomDiscountDetails } from '@components/PromotionVariantDiscountList';
import { DiscountDetails } from '@hooks/variant';
import { TFunction } from 'next-i18next';

export function getQuantityRelatedDiscount(discounts: DiscountDetails[]) {
  return discounts.find(discount => {
    const { type } = discount;
    return String(type) === 'quantity_based_multiple' || String(type) === 'quantity_based_threshold';
  });
}

export const caculateSuggestion = (tCommon: TFunction, currentQuantity: number, promotion?: CustomDiscountDetails) => {
  const { quantity_threshold: quantityThreshold = 0, quantity_multiple_of: quantityMultipleOf = 0 } =
    promotion?.requirements || { requirements: {} };
  if (promotion?.applied)
    return {
      children: tCommon('applied'),
    };
  if (promotion?.type === 'quantity_based_multiple') {
    if (currentQuantity === quantityMultipleOf)
      return {
        children: tCommon('applied'),
        disabled: true,
      };
    else if (currentQuantity < quantityMultipleOf) {
      return {
        children: tCommon('buy_more_piece', { quantity: quantityMultipleOf - currentQuantity }),
      };
    } else {
      let multiple = 1;
      while (currentQuantity > quantityMultipleOf * multiple) {
        multiple++;
      }
      return {
        children: tCommon('buy_more_piece', { quantity: quantityMultipleOf * multiple - currentQuantity }),
      };
    }
  }
  if (promotion?.type === 'quantity_based_threshold') {
    if (currentQuantity < quantityThreshold)
      return {
        children: tCommon('buy_more_piece', { quantity: quantityThreshold - currentQuantity }),
      };
    else
      return {
        children: tCommon('applied'),
        disabled: true,
      };
  }
  return null;
};

export const getMaxDiscountInPercentForProduct = (discounts: DiscountDetails[]) => {
  // Exclude basic discounts such as zk01 and zk05, since all variants have these discounts
  const discountProgram = discounts?.filter(discount => {
    return !['ZK01', 'ZK05'].includes(discount?.sapCode || '');
  });
  discountProgram?.sort((discountA, discountB) => Number(discountA?.percent) - Number(discountB?.percent));

  return discountProgram?.[0]?.percent;
};

export function calculateExtraQuantity(discount: DiscountDetails, quantity: number) {
  // discount is either quantity_based_multiple or quantity_based_multiple
  const { type, requirements } = discount;
  switch (String(type)) {
    case 'quantity_based_multiple': {
      if (quantity === 0) return requirements.quantity_multiple_of;
      let metQuantity = quantity;
      while (metQuantity % requirements.quantity_multiple_of !== 0) {
        metQuantity += 1;
      }
      return metQuantity - quantity;
    }

    default: {
      return Math.max(0, requirements.quantity_threshold - quantity);
    }
  }
}
